module.exports = __webpack_public_path__ + "static/home-banner-overlay-6671597634bcd1d10af8ae30c4e591a3.jpg";